<template>
  <MasterDetail
    ref="masterDetail"
    :cols="cols"
    :confirmDeleteMessage="confirmDeleteMessage"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :customResource="customResource"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";
import businessUnitsService from "@/api/ativacaoped/business-units.service";
import centrosCustoService from "@/api/ativacaoped/centros-de-custo.service";
import { createServiceResource } from "@/api/ativacaoped/resource-adapter";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {
        businessUnits: [],
        switchOpts: [
          {
            value: true,
            label: "Ativo"
          },
          {
            value: false,
            label: "Inativo"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      return [
        {
          key: "codigo",
          name: "Código",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        },
        {
          key: "nome",
          name: "Nome",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        },
        {
          key: "business_unit_id",
          name: "Business Unit",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "businessUnits", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        },
        {
          key: "ativo",
          name: "Status",
          type: this.$fieldTypes.SWITCH,
          defaultValue: true,
          rel: { to: "switchOpts", key: "value", name: "label" }
        }
      ];
    },
    /**
     * Resource service-backed consumido pelo `MasterDetail`
     * (`get` = grid/paginação, `save` = criar/editar, `delete` = excluir).
     * Substitui o `:resourceUrl`, que usava o `apiResource` inline do mixin.
     *
     * @returns {Object} Resource no contrato do `apiResource`
     */
    customResource() {
      // Ver nota em `divisoes.vue`: ler `clientId` aqui mantém o reload da grid
      // pelo watcher de `customResource` do `MasterDetail`.
      const clientId = this.clientId;

      return createServiceResource({
        notify: this.notify,
        get: ({ query }) => centrosCustoService.getCentrosCusto(clientId, query),
        save: (data, id) =>
          id
            ? centrosCustoService.putCentroCusto(clientId, id, data)
            : centrosCustoService.postCentroCusto(clientId, data),
        remove: id => centrosCustoService.deleteCentroCusto(clientId, id)
      });
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getBusinessUnits();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
        return;
      }

      // `opts.businessUnits` é carregado no `created`: na troca de empresa
      // precisa ser recarregado para o cliente novo.
      this.getBusinessUnits();
    }
  },
  methods: {
    confirmDeleteMessage({ nome }) {
      return `Deseja excluir o centro de custo ${nome}?`;
    },
    async getBusinessUnits() {
      try {
        const response = await businessUnitsService.getSelecaoBusinessUnits(
          this.clientId
        );
        this.opts.businessUnits = Array.isArray(response) ? response : [];
      } catch (error) {
        this.opts.businessUnits = [];
        this.notify(error);
      }
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    }
  }
};
</script>
